"use strict";
var $ = require("../internals/export");
var log1p = require("../internals/math-log1p");
$({ target: "Math", stat: true }, { log1p });
